// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "pdf.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "pdf.proto" (syntax proto3)
// tslint:disable
import { URLObject } from "./s3";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class HTML$Type extends MessageType {
    constructor() {
        super("HTML", [
            { no: 1, name: "data", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "owner_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = "";
        message.key = "";
        message.bucket = "";
        message.eventId = 0;
        message.ownerId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string data */ 1:
                    message.data = reader.string();
                    break;
                case /* string key */ 2:
                    message.key = reader.string();
                    break;
                case /* string bucket */ 3:
                    message.bucket = reader.string();
                    break;
                case /* int32 event_id */ 4:
                    message.eventId = reader.int32();
                    break;
                case /* int32 owner_id */ 5:
                    message.ownerId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string data = 1; */
        if (message.data !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.data);
        /* string key = 2; */
        if (message.key !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.key);
        /* string bucket = 3; */
        if (message.bucket !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.bucket);
        /* int32 event_id = 4; */
        if (message.eventId !== 0)
            writer.tag(4, WireType.Varint).int32(message.eventId);
        /* int32 owner_id = 5; */
        if (message.ownerId !== 0)
            writer.tag(5, WireType.Varint).int32(message.ownerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message HTML
 */
export const HTML = new HTML$Type();
/**
 * @generated ServiceType for protobuf service PDFService
 */
export const PDFService = new ServiceType("PDFService", [
    { name: "Create", options: {}, I: HTML, O: URLObject },
    { name: "CreateWithWeasyPrint", options: {}, I: HTML, O: URLObject }
]);
